import React, { useState } from 'react';
import './auth.css';
import './buttons.css';
import { ApiRequest } from '../../apiRequest';
import OtpSend from './OtpSend';
import OtpVerify from './OtpVerify';
import EmailInput from './EmailInput';

type AuthMethod = 'telegram' | 'email' | '';

const apiRequest = new ApiRequest();

const Auth: React.FC = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [method, setMethod] = useState<AuthMethod>('');
  const [secret, setSecret] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [errorOnVerification, setErrorOnVerification] = useState('');
  const [errorOnSend, setErrorOnSend] = useState('')

  const showError = (msg: any, setter: any, timeout = 10000) => {
    setter(msg);
    setTimeout(() => setter(''), timeout);
  };

  const handleEmailSubmit = async () => {
    const response = await apiRequest.checkEmailStatus(email);
    if (!response.success) {
      showError(response.message, setEmailError);
      return;
    }
    setStep(2);
  };

  const handleMethodSelect = async (targetMethod: AuthMethod) => {
    setMethod(targetMethod);
    setIsLoading(true);

    const response = await apiRequest.sendOtp(email, targetMethod);
    setIsLoading(false);

    if (!response.success) {
      showError(<>{response.message} <a className={"link"} href={"https://t.me/NexusApiDevBot"} rel={"noreferrer"} target={"_blank"}>Tap to fix.</a></>,
        setErrorOnSend);
      return;
    }

    setStep(3);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const response = await apiRequest.verifyOtp(email, method, secret);
    setIsLoading(false);

    if (!response.success) {
      showError(response.message, setErrorOnVerification)
    }
  };

  return (
    <div className="nexus-body">
      <div className="nexus-container">
        <div className="nexus-header">
          <img src="logo.svg" alt="NEXUS Logo" className="nexus-logo" />
        </div>

        {step === 1 && (
          <EmailInput
            email={email}
            errorMessage={emailError}
            onChange={setEmail}
            onSubmit={handleEmailSubmit}
          />
        )}

        {step === 2 && (
          <OtpSend
            isLoading={isLoading}
            method={method}
            onSelect={handleMethodSelect}
            onBack={() => setStep(1)}
            errorOnSend={errorOnSend}
          />
        )}

        {step === 3 && (
          <OtpVerify
            method={method}
            secret={secret}
            isLoading={isLoading}
            errorOnVerify={errorOnVerification}
            onChange={setSecret}
            onSubmit={handleSubmit}
            onBack={() => setStep(2)}
          />
        )}

        <div className="nexus-footer">
          &copy; {new Date().getFullYear()} NEXUS API SERVICE
        </div>
      </div>
    </div>
  );
};

export default Auth;
